import { UserSettingsService } from 'catalean-authentication';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private userSettingsService: UserSettingsService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        if (this.userSettingsService.getToken() && !request.url.includes(environment.authenticationUrl!)) {
          /*  if (request.url.includes('http://translator.datalean-nodejs.catalean.com/template/') 
            ||
                request.url.includes('http://localhost:3005/template/')) {
                request = request.clone({
                    setHeaders: {
                        // TODO add all needed with conditions
                        // TimeZoneOffset: new Date().getTimezoneOffset().toString(),
                        // Accept: 'application/json',
                        Authorization: 'Bearer ' + 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InF5Mk5SR01qem1UQVZmek16NUctczFGNFZKZG5nYmkySlRCVDVrWkhYYkEifQ.eyJ1c2VyVHlwZSI6IkFkbWluIiwiZXhwIjo0MDk5OTk5OTk5fQ.lXQg6UwCW40wPWClYOp1EaDc9dB95PNFqA9gEJlhH-mC-gHfk1HiHQU2FgDNhZ4U4aYhngmNoW0CGdz4scgpA9gD1IOdwAdKnrzY6gKplPxfi8r3J-kIk9H0EKM5gtmfmAa50upSZfgsOoy14CIwDzSe7J1-_TTUY6zbbIZr2BerkvhOuCLVpAJrOodsTd_iyAvYe2nsLXulOspR-v80uEbsJXXfseFr3jZAYfHBqcr2pQ4LTNrKHsYftzlpqKQWCYxJCBrV7_blAmtIiyLhUlw3O1JacR07M2O6XJt9DBMWTQ9jeLkBK0Gu3KfqkFs5CKYASoeaUdgyp-xKirZdaA'
                    }
                });
            } else {*/
                request = request.clone({
                    setHeaders: {
                        // TODO add all needed with conditions
                        // TimeZoneOffset: new Date().getTimezoneOffset().toString(),
                        // Accept: 'application/json',
                        Authorization: 'Bearer ' + this.userSettingsService.getToken().Token
                    }
                });
           // }
        } else {
            if ((request.method === 'GET' && request.url.includes('user') && request.url.includes('&query') )) {
                request = request.clone({
                    setHeaders: {
                        Authorization: 'Bearer ' + environment.systemUserToken
                    }
                });
            }
            if ((request.method === 'POST' && request.url.includes('user') && request.url.includes('reset-password') )) {
                request = request.clone({
                    setHeaders: {
                        Authorization: 'Bearer ' + environment.systemUserToken
                    }
                });
            }
            if ((request.method === 'GET' && request.url.includes('userstructure')) || (request.method === 'POST' && request.body?.status === 'REGISTERED') ||
                (request.method === 'GET' && request.url.includes('/catalean'))) {
                request = request.clone({
                    setHeaders: {
                        Authorization: 'Bearer ' + environment.systemUserToken
                    }
                });
            }
        }
        return next.handle(request);
    }
}
